<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->

<div class="csxheader">
  <i class='csx-people_crew'></i>

  <span class="csx-logo"> <img [src]="csxLogo" /> </span>

  <span class="appName">
		<span class="shortName">LMS</span>
  <span class="longName"> - Locomotive Management System {{(selectedTab?.type) ? " - " : ""}}{{(selectedTab?.type) ? selectedTab.type : ""}}</span>
  <span *ngIf="selectedTab?.type == 'Outlying-Points'">{{appUtilityService.showDeskName(selectedTab)?' - ':''}}{{appUtilityService.showDeskName(selectedTab)}}</span>
    <span class="maintenanceMsg">{{maintenanceMsg}}</span>
  </span>
  <lms-user-info class="user"></lms-user-info>
</div>
